<template>
  <section class="page">
    <div class="shape">
      <img src="@/assets/img/animation.png"/>
    </div>
    <svg class="animation" xmlns="http://www.w3.org/2000/svg" width="22" height="22"><text data-name="+" transform="matrix(1.437 1.434 -1.437 1.434 -.832 23.066)" font-size="25" fill="#27eac8" text-anchor="middle" font-family="Roboto"><tspan x="0">+</tspan></text></svg>
    <div class="shape2">
      <img src="@/assets/img/animated-bg2.png"/>
    </div>
    <svg class="shape3" width="21" height="20" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient x1="50%" y1="100%" x2="50%" y2="-49.891%" id="a">
          <stop stop-color="#00E92B" offset="0%"/>
          <stop stop-color="#CCFFA8" offset="100%"/>
        </linearGradient>
      </defs>
      <path transform="rotate(132 81.627 166.164)" d="M2 323l10.598 13L23 323z" stroke="url(#a)" stroke-width="2" fill="none" opacity=".659"/>
    </svg>
    <div class="page-content">
      <div class="title">
        <!-- <div class="shape">
          <svg xmlns="http://www.w3.org/2000/svg" width="28.562" height="28.594"><circle cx="14.281" cy="14.297" r="12.781" fill="none" stroke="#e1e1e1" stroke-width="3"/></svg>
        </div> -->
        <div class="box">
          <div class="ball-box">
             <svg class="ball" xmlns="http://www.w3.org/2000/svg" width="28.562" height="28.594"><circle cx="14.281" cy="14.297" r="12.781" fill="none" stroke="#e1e1e1" stroke-width="3"/></svg>
          </div>
        </div>
        <h2 class="content">关于我们</h2>
        <div class="box2">
          <div class="triangle-ball">
             <svg class="triangle" width="21" height="20" xmlns="http://www.w3.org/2000/svg">
              <!-- <defs>
                <linearGradient x1="50%" y1="100%" x2="50%" y2="-49.891%" id="a">
                  <stop stop-color="#00E92B" offset="0%"/>
                  <stop stop-color="#CCFFA8" offset="100%"/>
                </linearGradient>
              </defs> -->
              <path transform="rotate(132 81.627 166.164)" d="M2 323l10.598 13L23 323z" stroke="url(#a)" stroke-width="2" fill="none" opacity=".659"/>
            </svg>
          </div>
        </div>
      </div>
      <div class="page-content-top">
        <div class="image" >
          <img class="animated pulse" src="@/assets/img/about.png"/>
        </div>
        <div class="introduction">
          <h2 class="subtitle">公司简介</h2>
          <span class="spacing"></span>
          <p class="paragraph">
            深圳市艾迪科物联网技术有限公司（Shenzhen IDCO Internet of Things Technology Co.,LTD）
            是一家致力于物联网、工业互联网、新能源、电力领域以及企业信息一体化平台研发的技术企业，公司总部
            在深圳，在哈尔滨设有研发中心。
          </p>
          <p class="paragraph">
           拥有8年工业互联网系统研发团队。公司自有产品为智慧能源管控云平台。
          </p>
          <p class="paragraph">
            服务客户主要包括深圳万科、碧桂园、比亚迪、惠州潼湖小镇、湛江港、深圳机场和地铁等，并为其提供行
            业相关软件配套服务。
          </p>
        </div>
      </div>
      <!-- <div class="page-content-bottom">
        <div class="page-content-bottom-item">
          <h3 class="subheading">智慧能源管控平台</h3>
          <p class="secondary">
            1.利用移动互联网、人工智能、自动化控制、物联网等现代信息技术
            <br/>
            2.对电力设备进行7*24小时的自动化数据采集与数据分析，加强电力系统的实时监测和故障诊断
            <br/>
            3.实现企业电力调度、电力监控、设备管理、电力运维等一体化管控
          </p>
        </div>
        <div class="page-content-bottom-item">
          <h3 class="subheading">平台适用</h3>
          <p class="secondary">
            港口、机场、工厂、园区、新能源应用等大型用电企业，为多应用场景构建工业能源 IoT 解决方案。
            <br/>
            依托平台应用，实现变电站无人化管理，提升企业变电站运维管理工作的灵活性、电力系统运行的安全性与稳定性，
            <br/>
            降低运维管理成本，推动企业变电站的可持续发展。
          </p>
        </div>
        <div class="page-content-bottom-item">
          <h3 class="subheading">平台价值</h3>
          <p class="secondary">
            1.高安全、高可靠运行（环境监控、故障抢修全程跟踪和电力设备属性预警阀值配置，智能预警及联动）
            <br/>
            2.智慧运维一体化管控（APP在线电力生产管理功能，电力生产管理与电力监控一体化）
            <br/>
            3.AI高效分析和决策（大屏数据可视化展示分析，提升监测电力和智慧决策的能力和效率水平）
          </p>
        </div>
      </div> -->
    </div>
  </section>
</template>

<script>
export default {
  name: "page"
}
</script>

<style lang="scss" scoped>
.page {
  background-color: #ffffff;
  padding: 70px 0;
  padding-top: 0px;
  position: relative;

  @media (max-width: 576px) {
    .shape2{
      img{
        display: none;
      }
    }

    .animation{
      display: none;
    }
  }

  .shape {
    position: absolute;
    top: 0px;
    left: 10px;
    z-index: 1;
    opacity: 0.4;

    img {
      animation: rotate 4s linear infinite;
      -webkit-animation: rotate 4s linear infinite;
      
      @-webkit-keyframes rotate {
        from {
          -webkit-transform: rotateY(360deg);
        }
        to {
          -webkit-transform: rotateY(0deg);
        }
      }
     
      @keyframes rotate {
        from {
          -webkit-transform: rotateY(360deg);
        }
        to {
          -webkit-transform: rotateY(0deg);
        }
      }
    }
  }

  .shape2 {
    position: absolute;
    top: 0px;
    right: 10px;
    z-index: 1;
    opacity: 0.2;

    img {
      animation: movebounce 4s linear infinite;
      -webkit-animation: movebounce 4s linear infinite;
    }

    @keyframes movebounce {
      0%,
      100% {
        transform: translateY(0px);
        -webkit-transform: translateY(0px);
      }
      
      50% {
        transform: translateY(20px);
        -webkit-transform: translateY(20px);
      }
    }
  }

  .shape3 {
    position: absolute;
    top: 100px;
    right: 80px;
    z-index: 1;
    animation: triangle 20s infinite linear;

    @keyframes triangle {
      0% {
        -webkit-transform: rotate(0deg);
        -moz-transform: rotate(0deg);
        -ms-transform: rotate(0deg);
        -o-transform: rotate(0deg);
        transform: rotate(0deg);
      }

      100% {
        -webkit-transform: rotate(360deg);
        -moz-transform: rotate(360deg);
        -ms-transform: rotate(360deg);
        -o-transform: rotate(360deg);
        transform: rotate(360deg);
      }
    }
  }

  .animation {
    position: absolute;
    top: 120px;
    left: 150px;
    z-index: 1;
    animation: circle 20s infinite linear;

    @-webkit-keyframes circle {
      0% {
        -webkit-transform: rotate(0deg);
        -moz-transform: rotate(0deg);
        -ms-transform: rotate(0deg);
        -o-transform: rotate(0deg);
        transform: rotate(0deg);
      }

      100% {
        -webkit-transform: rotate(360deg);
        -moz-transform: rotate(360deg);
        -ms-transform: rotate(360deg);
        -o-transform: rotate(360deg);
        transform: rotate(360deg);
      }
    }

    @-moz-keyframes circle {
      0% {
        -webkit-transform: rotate(0deg);
        -moz-transform: rotate(0deg);
        -ms-transform: rotate(0deg);
        -o-transform: rotate(0deg);
        transform: rotate(0deg);
      }

      100% {
        -webkit-transform: rotate(360deg);
        -moz-transform: rotate(360deg);
        -ms-transform: rotate(360deg);
        -o-transform: rotate(360deg);
        transform: rotate(360deg);
      }
    }

    @-ms-keyframes circle {
      0% {
        -webkit-transform: rotate(0deg);
        -moz-transform: rotate(0deg);
        -ms-transform: rotate(0deg);
        -o-transform: rotate(0deg);
        transform: rotate(0deg);
      }

      100% {
        -webkit-transform: rotate(360deg);
        -moz-transform: rotate(360deg);
        -ms-transform: rotate(360deg);
        -o-transform: rotate(360deg);
        transform: rotate(360deg);
      }
    }

    @-o-keyframes circle {
      0% {
        -webkit-transform: rotate(0deg);
        -moz-transform: rotate(0deg);
        -ms-transform: rotate(0deg);
        -o-transform: rotate(0deg);
        transform: rotate(0deg);
      }

      100% {
        -webkit-transform: rotate(360deg);
        -moz-transform: rotate(360deg);
        -ms-transform: rotate(360deg);
        -o-transform: rotate(360deg);
        transform: rotate(360deg);
      }
    }

    @keyframes circle {
      0% {
        -webkit-transform: rotate(0deg);
        -moz-transform: rotate(0deg);
        -ms-transform: rotate(0deg);
        -o-transform: rotate(0deg);
        transform: rotate(0deg);
      }

      100% {
        -webkit-transform: rotate(360deg);
        -moz-transform: rotate(360deg);
        -ms-transform: rotate(360deg);
        -o-transform: rotate(360deg);
        transform: rotate(360deg);
      }
    }
  }
}

.page-content {
  align-items: center;
  position: relative;
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;

  @media (max-width: 576px) {
    padding: 0px;

    .box{
      width: 90%;
      left: 5%;
    }

    .box2{
      display: none;
    }

    .subtitle{
      text-align: center;
    }

    .paragraph {
      text-indent: 25px;
    }
  }

  @media (min-width: 576px) {
    max-width: 540px;
  }

  @media (min-width: 768px) {
    max-width: 620px;
  }

  @media (max-width: 992px) {
    .title {
      background: url(../../assets/img/banner-bg1.jpg) center no-repeat;
    }

    .page-content-top {
      display: block;
      .introduction {
        margin-top: 30px;
      }
    }

    .page-content-bottom {
      display: block;
      margin-top: 30px;
      .page-content-bottom-item {
        margin-top: 30px;
      }
    }
  }

  @media (min-width: 992px) {
    max-width: 860px;
  }

  @media (min-width: 1200px) {
    max-width: 1140px;
  }
}

.title {
  position: relative;
  font-family: "";
  width: 100%;
  padding-top: 120px;
  padding-bottom: 100px;
  background: url(../../assets/img/banner-bg1.jpg) right top no-repeat;
  
  .content {
    font-size: 24px;
    font-weight: 700;
    color: #0e314c;
  }
  
  .box2 {
    width: 200px;
    height: 80px;
    position: absolute;
    right: 100px;
    bottom: 4px;
  }
  
  .triangle-box {
    width: 30px;
    height: 30px;
    animation: animate linear 3s infinite;
    -webkit-animation: animate linear 3s infinite;
  }
  
  .triangle {
    width: 30px;
    height: 30px;
    animation: animat linear 5s infinite;
    -webkit-animation: animat linear 5s infinite;
  }
  
  @keyframes animate {
    0%,
    100% {
      transform: translateY(0px);
      -webkit-transform: translateY(0px);
    }

    50% {
      transform: translateY(60px);
      -webkit-transform: translateY(60px);
    }
  }

  @keyframes animat {
    0%,
    100% {
      transform: translateX(0px);
      -webkit-transform: translateX(0px);
    }

    50% {
      transform: translateX(180px);
      -webkit-transform: translateX(180px);
    }
  }
}

.page-content-top {
  display: flex;
  align-items: center;
  padding-top: 60px;

  .introduction {
    padding: 0 15px;
    text-align: left;
    flex: 1;

    .subtitle {
      margin: 0;
      color: #0e314c;
      font-size: 20px;
      font-weight: 600;
    }

    .spacing {
      display: block;
      width: 100%;
      height: 5px;
    }

    .paragraph {
      font-family: "Microsoft YaHei";
      color: #6084a4;
      line-height: 1.9;
      font-size: 14px;
      margin: 10px 0px;
    }

    button {
      background-color: #e36cd9;
      box-shadow: 0 13px 27px 0 rgba(244, 134, 101, 0.25);
      color: #ffffff;
      border: none;
      padding: 12px 36px;
      position: relative;
      border-radius: 4px;
      z-index: 1;
      text-transform: uppercase;
      -webkit-transition: 0.5s;
      transition: 0.5s;
      font-weight: 600;
      font-size: 13px;
    }
  }
}

.page-content-bottom {
  display: flex;
  margin-top: 60px;
  text-align: left;

  .page-content-bottom-item {
    flex: 1;
    padding: 0 15px;

    .subheading {
      margin: 0;
      color: #0e314c;
      font-size: 16px;
      font-weight: 600;
    }

    .secondary {
      color: #6084a4;
      line-height: 1.9;
      font-size: 13px;
      margin-top: 15px;
      margin-bottom: 20px;
      letter-spacing: 2px;
    }
  }
}

.image {
  position: relative;
  text-align: center;
  flex: 1;
  padding: 0 15px;

  img {
    max-width: 100%;
    height: auto;
  }
}

.box {
  width: 300px;
  height: 150px;
  // border: 1px solid #7aa4c0;
  position: absolute;
  left: 15%;
  bottom: 2%;
}

.ball-box {
  width: 30px;
  height: 30px;
  animation: bouncey linear 3s infinite;
  -webkit-animation: bouncey linear 3s infinite;
}

.ball {
  width: 30px;
  height: 30px;
  animation: bouncex linear 5s infinite;
  -webkit-animation: bouncex linear 5s infinite;
}

@keyframes bouncey {
  0%,
  100% {
    transform: translateY(0px);
    -webkit-transform: translateY(0px);
  }

  50% {
    transform: translateY(130px);
    -webkit-transform: translateY(130px);
  }
}

@keyframes bouncex {
  0%,
  100% {
    transform: translateX(0px);
    -webkit-transform: translateX(0px);
  }
  
  50% {
    transform: translateX(280px);
    -webkit-transform: translateX(280px);
  }
}
</style>